import textHeadlineContent from './blocks/textHeadlineContent';
import tableContent from './blocks/tableContent';
import sbPostEmptyContent from './blocks/sbPostEmptyContent';
import imageParagraphContent from './blocks/imageParagraphContent';
import imageTextColumns from './blocks/imageTextColumns';
import videoText from './blocks/videoText';
import blockQuote from './blocks/blockQuote';
import socialReactionsSurvey from './blocks/socialReactionsSurvey';
import thumbsSurvey from './blocks/thumbsSurvey';
import starRatingSurvey from './blocks/starRatingSurvey';
import numericRatingSurvey from './blocks/numericRatingSurvey';
import enpsSurvey from './blocks/enpsSurvey';
import socialLinksContent from './blocks/socialLinksContent';
import lineDividerContent from './blocks/lineDividerContent';

export default [
    {
        nameRef: 'text-headline',
        blockContent: textHeadlineContent,
    },
    {
        nameRef: 'table-content',
        blockContent: tableContent,
    },
    {
        nameRef: 'sb-post-empty',
        blockContent: sbPostEmptyContent,
    },
    {
        nameRef: 'image-paragraph',
        blockContent: imageParagraphContent,
    },
    {
        nameRef: 'image-text-columns',
        blockContent: imageTextColumns,
    },
    {
        nameRef: 'video-text',
        blockContent: videoText,
    },
    {
        nameRef: 'text-quote',
        blockContent: blockQuote,
    },
    {
        nameRef: 'survey-social-reactions',
        blockContent: socialReactionsSurvey,
    },
    {
        nameRef: 'survey-thumbs',
        blockContent: thumbsSurvey,
    },
    {
        nameRef: 'survey-stars',
        blockContent: starRatingSurvey,
    },
    {
        nameRef: 'survey-numeric',
        blockContent: numericRatingSurvey,
    },
    {
        nameRef: 'survey-enps',
        blockContent: enpsSurvey,
    },
    {
        nameRef: 'social-links',
        blockContent: socialLinksContent,
    },
    {
        nameRef: 'line-divider',
        blockContent: lineDividerContent,
    },
];
